import type { FC, ReactElement } from 'react'

import tw, { styled } from 'twin.macro'
import Head from 'next/head'
import Link from 'next/link'

import AppLayout from '@/providers/AppLayout'

import WikiIcon from '../lib/svgs/wiki.svg'

const Brief = styled.div`
  ${tw`text-sm font-primary mt-4 pb-4 md:mt-14 md:pb-9 relative`}

  &:after {
    ${tw`h-1 w-[12.7vw] bg-brand absolute bottom-0 left-0`}
    content: "";
  }
`

const PageHeading: React.FC = () => {
  return (
    <header tw="max-w-[98rem] lg:mx-auto px-5 pt-[12.5vw] pb-[8.75vw] relative z-10">
      <h1 tw="text-5xl md:text-[80px] font-secondary text-white">PhalaWorld Docs</h1>
      <Brief>
        You can find out everything about PhalaWorld here.
      </Brief>
    </header>
  )
}

const BackgroundIllustraction = styled.div`
  ${tw`absolute top-0 right-0 select-none pointer-events-none z-0 md:w-[62.96875vw] md:h-[51.5625vw]`}
  background: url('/static/images/teamPage/bg.jpg') no-repeat 100% 0;
  background-size: 100%;
`

const LinkBlock: FC<{ url: string, title: string }> = ({ url, title }) => {
  return (
    <div tw="border-b border-dashed border-[#8c8c8c] pb-5 flex flex-row gap-5 col-span-5">
      <div tw="rounded border border-brand-500 w-11 h-11 flex flex-row justify-center items-center min-w-[2.75rem]">
        <WikiIcon tw="w-3/5 text-white" />
      </div>
      <Link href={url} passHref target="_blank" tw="flex-wrap">
        <h4 tw="text-xl font-secondary leading-none mb-4">{title}</h4>
        <p tw="text-base text-[#54958C] underline break-all">
          {url}
        </p>
      </Link>
    </div>
  );
}

export default function DocsPage() {
  return (
    <>
      <Head>
        <title>Docs | PhalaWorld</title>
      </Head>
      <PageHeading />
      <div tw="bg-[#111] h-screen w-full">
        <div tw="absolute top-0 left-0 z-0 bg-[#111] md:h-[51.5625vw] w-full xl:px-0">
          <BackgroundIllustraction />
        </div>
        <div tw="relative z-10 grid grid-cols-12 gap-10 pt-32 pb-16 max-w-[98rem] lg:mx-auto px-5 py-6">
          <LinkBlock
            title="What is PhalaWorld?"
            url="https://docs.phala.world/"
          />
          <LinkBlock
            title="Shell mint schedule"
            url="https://docs.phala.world/introduction/mint-information/mint-process-of-shell-nft"
          />
          <LinkBlock
            title="Incubation of Shell"
            url="https://docs.phala.world/introduction/the-shell-nft/feeding-and-incubating"
          />
          <LinkBlock
            title="PhalaWorld NFT system"
            url="https://docs.phala.world/introduction/interaction-of-phalaworld-nfts"
          />
          <LinkBlock
            title="What is Spirit NFT?"
            url="https://docs.phala.world/introduction/the-spirit-nft"
          />
          <LinkBlock
            title="How to upgrade Spirit attribute?"
            url="https://docs.phala.world/introduction/the-spirit-nft/attributes"
          />
          <LinkBlock
            title="Spirit world rank"
            url="https://docs.phala.world/introduction/the-spirit-nft/spirit-world-ranks"
          />
          <LinkBlock
            title="What is Seal NFT?"
            url="https://docs.phala.world/introduction/the-seal-nft"
          />
          <LinkBlock
            title="How to create a Khala account?"
            url="https://docs.phala.world/geting-started/how-to-create-a-khala-account"
          />
          <LinkBlock
            title="How to get K-PHA?"
            url="https://docs.phala.world/geting-started/where-to-get-pha-khala-chain"
          />
          <LinkBlock
            title="How to claim Spirit?"
            url="https://docs.phala.world/geting-started/how-to-claim-spirit"
          />
          <LinkBlock
            title="How to mint Shell?"
            url="https://docs.phala.world/geting-started/how-to-mint-shell-nft"
          />
          <LinkBlock
            title="Bug report"
            url="https://docs.google.com/forms/d/e/1FAIpQLSeiQ9zZE4ZfxwQlAQnRHRrmG4pmU1QTI4rH7dxcYMH4VsjYhA/viewform"
          />
          <LinkBlock
            title="Official link"
            url="https://docs.phala.world/important/resource"
          />
        </div>
      </div>
    </>
  )
}

DocsPage.getLayout = (page: ReactElement) => {
  return (
    <AppLayout>
      {page}
    </AppLayout>
  )
}
